import { useNavigate } from 'react-router-dom';
import { Badge } from '@/components/ui';
import { TablePagination } from '@/components/ui/TablePagination';
import { Wind, Zap, Droplet, Lightbulb } from 'lucide-react';
import type { UtilitySystem } from '../types/utility.types';

// ICONS mapping removed since we use utility.png

const STATUS_MAP: Record<string, { label: string; className: string }> = {
  operational: { label: 'Hoạt động', className: 'bg-emerald-50 text-emerald-600 border-emerald-100' },
  active:       { label: 'Hoạt động', className: 'bg-emerald-50 text-emerald-600 border-emerald-100' },
  installing:   { label: 'Đang lắp đặt', className: 'bg-blue-50 text-blue-600 border-blue-100' },
  testing:      { label: 'Kiểm tra', className: 'bg-indigo-50 text-indigo-600 border-indigo-100' },
  maintenance_due: { label: 'Cần bảo trì', className: 'bg-orange-50 text-orange-600 border-orange-100' },
  maintenance:  { label: 'Đang bảo trì', className: 'bg-orange-50 text-orange-600 border-orange-100' },
  faulty:       { label: 'Sự cố', className: 'bg-rose-50 text-rose-600 border-rose-100' },
  under_repair: { label: 'Đang sửa', className: 'bg-amber-50 text-amber-600 border-amber-100' },
  inactive:     { label: 'Ngừng hoạt động', className: 'bg-slate-100 text-slate-500 border-slate-200' },
  retired:      { label: 'Thanh lý', className: 'bg-slate-100 text-slate-400 border-slate-200' },
};

interface UtilityMobileCardsProps {
  items: UtilitySystem[];
  total: number;
  page: number;
  pageSize: number;
  isLoading: boolean;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

export function UtilityMobileCards({
  items,
  total,
  page,
  pageSize,
  isLoading,
  onPageChange,
  onPageSizeChange,
}: UtilityMobileCardsProps) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col h-full space-y-3">
      {isLoading ? (
        Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="bg-white rounded-md border border-slate-100 p-4 animate-pulse">
            <div className="flex gap-3">
              <div className="w-10 h-10 rounded-md bg-slate-100 shrink-0" />
              <div className="flex-1 space-y-2">
                <div className="h-3 bg-slate-100 rounded w-3/4" />
                <div className="h-2.5 bg-slate-100 rounded w-1/2" />
              </div>
            </div>
          </div>
        ))
      ) : items.map((item) => {
        const status = STATUS_MAP[item.status_code] ?? { label: item.status_code, className: 'bg-slate-50 text-slate-500' };
        return (
          <div key={item.id} onClick={() => navigate(`/utility/detail/${item.id}`)} className="bg-white rounded-md border border-slate-100 p-4 cursor-pointer hover:border-slate-200 transition-colors">
            <div className="flex items-start gap-3">
              <img src="/assets/other/img/utility.png" alt={item.system_name} className="w-10 h-10 rounded-md shrink-0 object-cover border border-slate-100" />
              <div className="flex-1 min-w-0">
                <p className="sm:text-sm text-xs text-slate-800">{item.system_name}</p>
                <p className="text-xs text-slate-400 mt-0.5">{item.system_code} • {item.system_type}</p>
                <div className="mt-2">
                  <Badge className={`rounded border sm:text-xs text-[10px] px-2 py-0.5 ${status.className}`}>{status.label}</Badge>
                </div>
              </div>
            </div>
          </div>
        );
      })}
      <TablePagination 
        total={total} 
        page={page} 
        pageSize={pageSize} 
        onPageChange={onPageChange} 
        onPageSizeChange={onPageSizeChange} 
      />
    </div>
  );
}
